import { render, staticRenderFns } from "./BaseService.vue?vue&type=template&id=480c4254&"
import script from "./BaseService.vue?vue&type=script&lang=js&"
export * from "./BaseService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports